export const serviceAreas = [
  {
    id: "chicago-west",
    label: "Chicago & West",
    locations: [
      { city: "Chicago", state: "IL" },
      { city: "Oak Park", state: "IL" },
      { city: "Berwyn", state: "IL" },
      { city: "Elmhurst", state: "IL" },
      { city: "Naperville", state: "IL" },
    ],
  },
  {
    id: "north-northwest",
    label: "North & Northwest",
    locations: [
      { city: "Evanston", state: "IL" },
      { city: "Skokie", state: "IL" },
      { city: "Des Plaines", state: "IL" },
      { city: "Schaumburg", state: "IL" },
      { city: "Arlington Heights", state: "IL" },
    ],
  },
  {
    id: "south-southwest",
    label: "South & Southwest",
    locations: [
      { city: "Homewood", state: "IL" },
      { city: "Orland Park", state: "IL" },
      { city: "Tinley Park", state: "IL" },
      { city: "Palos Heights", state: "IL" },
      { city: "Calumet City", state: "IL" },
    ],
  },
  {
    id: "northwest-indiana",
    label: "Northwest Indiana",
    locations: [
      { city: "Hammond", state: "IN" },
      { city: "Munster", state: "IN" },
      { city: "Highland", state: "IN" },
      { city: "Schererville", state: "IN" },
      { city: "Crown Point", state: "IN" },
    ],
  },
];
